import React from 'react';
import ajax from '../../utils/ajax';
import dictionary from '../../utils/dictionary';
import functions from '../../utils/functions';
import ActivityLoader from '../Common/ActivityLoader';
import AlertError from '../Common/AlertError';
import AlertSuccess from '../Common/AlertSuccess';
import TextInput from '../Common/TextInput';
import TextInputDisabled from '../Common/TextInputDisabled';
import PopPaymentSummary from '../Payments/PopPaymentSummary';

class PopWhiteListPayment extends React.Component {

    state = {
        amount: '',
        depositorContact: '',
        depositorName: '',
        info: '',
        whiteList:this.props.whiteList
    }

    onChangeAmount = (event) => {
        this.setState({ amount: event.target.value })
    }

    onChangeDepositorContact = (event) => {
        this.setState({ depositorContact: event.target.value })
    }

    onChangeDepositorName = (event) => {
        this.setState({ depositorName: event.target.value })
    }


    makeOfficePayment = async (depositorName, depositorContact) => {

        this.setState({
            info: <ActivityLoader />,
            officePayment: false
        })
        const server_response = await ajax.makeWhiteListPayment(
            this.state.whiteList.request_id,
            depositorName,
            depositorContact
        )

        if (server_response.status === "OK") {
            //load receipt
            functions.closePopup("modal_white_list_office_payment");
            this.props.onConfirm(<AlertSuccess message={server_response.details.message} />)
            this.setState({
                receipt: <PopPaymentSummary record={server_response.details.content} />
            }, () => {
                functions.openPopup("modal_payment_summary");
            })
        } else {
            this.setState({
                info: <AlertError message={server_response.details.message} />
            })
        }
    }




    onConfirm = (event) => {
        event.preventDefault();
        const {depositorContact, depositorName } = this.state
        if (depositorContact.length > 0 && depositorName.length > 0) {

            this.makeOfficePayment(depositorName, depositorContact);

        } else {
            this.setState({
                info: <AlertError message={dictionary._completeFields} />
            })
        }
    }




    render() {
        const whiteList=this.state.whiteList
        return (
            <>
                {this.state.receipt}
                <div className="modal" id="modal_white_list_office_payment">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">


                        <div className="modal-content modal-content-demo shadow">
                            <div className="modal-header">
                                <h6 className="modal-title">New Cash Payment(White List)</h6>
                                <button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body">
                                {this.state.info}
                                <form method="post" onSubmit={this.onConfirm}>

                                    <TextInputDisabled
                                          label="Commitment Amount"
                                          value={"UGX " + whiteList.due_amount.amount_c}
                                    />

                                    <TextInputDisabled
                                          label="Balance Date"
                                          value={whiteList.balance_date.short_date}
                                    />
                                     

                                    <TextInput
                                        label="Depositor's Name"
                                        type="text"
                                        onChange={() => this.onChangeDepositorName}
                                        value={this.state.depositorName}
                                    />

                                    <TextInput
                                        label="Depositor's Contact"
                                        type="text"
                                        onChange={() => this.onChangeDepositorContact}
                                        value={this.state.depositorContact}
                                    />

                                </form>




                            </div>
                            <div className="modal-footer">
                                <button className="btn ripple btn-success" type="button" onClick={this.onConfirm}>Confirm Payment</button>
                                <button className="btn ripple btn-secondary" type="button" data-dismiss="modal">Close</button>
                            </div>
                        </div>


                    </div>
                </div>
            </>
        )


    }
}

export default PopWhiteListPayment;
